import Heading from "@vfuk/core-heading";
import SimpleGrid from "@vfuk/core-simple-grid";
import Icon from "@vfuk/core-icon";
import Spacing from "@vfuk/core-spacing";
import Container from "@vfuk/core-container/";
import Paragraph from "@vfuk/core-paragraph/";
import { ReactNode } from "react";
import "./SectionBanner.css";

type SectionBannerProps = {
  id?: string;
  heading: string;
  subtitle?: string;
  iconName?: string;
  moreElements?: ReactNode;
  image: string;
};

const SectionBanner = ({
  heading,
  subtitle,
  iconName,
  moreElements,
  image,
}: SectionBannerProps): JSX.Element => {
  return (
    <Container
      id="banner_section" // Used in CSS to remove the border-radius that comes by default
      appearance="secondary"
      enableOverlay={false}
      paddingLevel={5}
      backgroundImage={{
        sm: {
          src: image,
        },
      }}
    >
      <SimpleGrid
        verticalAlign="center"
        spacing={0}
        layout={{ sm: [1, 9, 2], lg: [0.5, 10, 1] }}
      >
        <Spacing spacingLevel={{ right: 0 }}>
          {iconName && <Icon size={4} name={iconName} />}
        </Spacing>

        <>
          <Heading level={4} weight={2} noMargin text={heading} inverse />
          {subtitle && (
            <Paragraph size={2} inverse>
              {subtitle}
            </Paragraph>
          )}
        </>

        {moreElements && moreElements}
      </SimpleGrid>
    </Container>
  );
};

export default SectionBanner;
